import { useApiQuery } from '../useApiQuery';
import { depositKeys } from '@/lib/queryKeys';
import { depositEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api/client';
import type { Deposit } from '@/types/deposit';

/** Spec §4 — single deposit with applications joined. */
export function useDeposit(id: string | undefined) {
  return useApiQuery<Deposit>({
    queryKey: depositKeys.detail(id ?? '__placeholder__'),
    queryFn: () => apiGet<Deposit>(operationsClient, depositEndpoints.detail(id ?? '')),
    enabled: Boolean(id),
    showErrorToast: false,
  });
}
